import React from 'react';
import cn from 'classnames';

import styles from './Loader.module.postcss';

function Loader({ isLoading = true, children, padded, centered = false, small = false }) {

  if (!isLoading) {
    return children;
  }

  return (
    <div
      className={cn({
        [styles.Loader__padded]: padded,
        [styles.Loader__centered]: centered,
        [styles.Loader__small]: small
      })}
      role="status"
      aria-label="Loading"
    >
      <div className={styles.Loader} />
    </div>
  );
}

export default Loader;
